import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import TrackShipmentModule from './TrackShipmentModule';
import url from './url';

function Tracking() {
    const location = useLocation();
    const [trackingNumber, setTrackingNumber] = useState(location.state?.trackingNumber || '');
    const [trackingData, setTrackingData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchTrackingInfo = async (e) => {
        e.preventDefault();
        if (!trackingNumber.trim()) {
            setError('Please enter a tracking number');
            return;
        }

        setLoading(true);
        setError(null);

        try {
            const response = await fetch(`${url}/api/tracking/track/${trackingNumber}`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );

            const data = await response.json();
            console.log(data)
            if (!data.success) {
                throw new Error(data.message || 'Error fetching tracking information');
            }

            setTrackingData(data.data);
        } catch (err) {
            setError(err.message || 'Error fetching tracking information. Please try again.');
            console.error('Tracking fetch error:', err);
        } finally {
            setLoading(false);
        }
    };
    return (
        <div className="container tracking-page">
            <div className="tracking-intro">
                <span className="section-kicker">SHIPMENT VISIBILITY</span>
                <h1>Know where it is.<br /><em>Know what’s next.</em></h1>
                <p>Enter your tracking number to see the latest movement and delivery status.</p>
                <form onSubmit={fetchTrackingInfo} className="w-100 max-w-md center-center">
                    <div className="input-group tracking-input-container">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="e.g. CW12345678"
                            value={trackingNumber}
                            onChange={(e) => setTrackingNumber(e.target.value)}
                            aria-label="Tracking number"
                        />
                        <div className="input-group-append">
                            <button 
                                className="btn btn-outline-secondary" 
                                type="submit"
                                disabled={loading}
                            >
                                {loading ? 'Searching…' : 'Track shipment'}
                            </button>
                        </div>
                    </div>
                </form>
                <div className="tracking-hint"><span className="status-dot"></span> Your tracking number is in your booking confirmation email.</div>

                {error && (
                    <div className="alert alert-danger tracking-alert" role="alert">
                        {error}
                    </div>
                )}

                {loading && (
                    <div className="tracking-loading" role="status">
                        <div className="spinner-border">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <span>Finding the latest update…</span>
                    </div>
                )}

                {trackingData && (
                    <div className="d-flex justify-content-center align-items-center mt-4 w-100">
                        <TrackShipmentModule trackingData={trackingData} />
                    </div>
                )}
            </div>
        </div>
    );
}

export default Tracking
